import { useCallback, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useBackend } from "../backend/BackendProvider";
import { migrateOfflineSchedules } from "./offline";
import { useToast } from "../components/ToastProvider";

export function ScheduleMigrationEngine() {
  const backend = useBackend();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { show } = useToast();
  const [failed, setFailed] = useState(false);
  const [running, setRunning] = useState(false);

  const run = useCallback(async () => {
    setRunning(true);
    try {
      const localCount = migrateOfflineSchedules();
      const remote = await backend.data.consumeScheduleMigration();
      const affected = localCount + remote.affectedTasks;
      setFailed(false);
      if (affected > 0) {
        await queryClient.invalidateQueries();
        show(`${affected} ${affected === 1 ? "Task was" : "Tasks were"} moved to Today. All other information is unchanged.`, { label: "View Today", run: () => navigate("/today") });
      }
    } catch {
      setFailed(true);
    } finally {
      setRunning(false);
    }
  }, [backend, navigate, queryClient, show]);

  useEffect(() => { void run(); }, [run]);
  return failed ? <div className="migration-error" role="alert"><span>Schedule migration failed. Your data is unchanged.</span><button className="button small" disabled={running} onClick={() => void run()}>{running ? "Retrying…" : "Retry Migration"}</button></div> : null;
}
